import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';
import Image from '../../Atoms/Image';
import CardBenefits from '../../Molecules/CardBenefits';
import LogoList from '../../Molecules/LogoList';
import ImageCarousel from '../../Molecules/ImageCarousel';
import {
  CardWorkspaceList,
  Props as CardWorkspaceProps
} from '../../Molecules/CardWorkspace';

import Robot from '../../../assets/img/robot.png';
import heroBg from '../../../assets/img/clients-hero-bg.png';

import cards from '../../../data/cardWorkspacesListData';

import {
  slides,
  logos
} from '../../../data/logosListAndImageSliderData';

function Clients() {
  return (
    <>
      <div className="relative bg-white pt-24 pb-12 md:pb-24 md:pt-56">
        <div className="relative z-20 mx-auto w-full max-w-7xl px-7">
          <div className="flex flex-col-reverse items-stretch justify-center gap-7 md:flex-row">
            <div className="w-full md:w-1/2">
              <Text font="circular">
                <span className="text-lg md:text-xl lg:text-2xl">
                  Your tech team, our job
                </span>
              </Text>
              <Title
                as="h1"
                leading="none"
                className="mb-8"
              >
                Partner voor technische werkgevers
              </Title>
              <Text font="circular">
                <span>
                  Waar het jullie corebusiness is om te
                  ontwikkelen, engineeren en produceren, is
                  het onze corebusiness om hier de{' '}
                  <a href="#!">Monteurs</a> en{' '}
                  <a href="#!">Engineers</a> voor aan te
                  trekken.
                </span>
              </Text>
            </div>
            <div className="flex w-full items-center justify-center md:w-1/2">
              <Image src={Robot} alt="Robot" />
            </div>
          </div>
          <div className="mt-10 grid w-full grid-cols-1 gap-7 lg:mt-40 lg:grid-cols-3 lg:gap-3">
            <CardBenefits
              title="Verzekerd van continuïteit"
              text="Grote kans dat wij de techneut die jij zoekt al kennen. Zo kunnen we snel schakelen en kan jij gewoon door."
              icon="rocket-regular"
            />
            <CardBenefits
              title="Alleen passende kandidaten"
              text="Kies voor de kwaliteit van een engineeringsbureau middels een deta-vast oplossing."
              icon="file-contract-regular"
            />
            <CardBenefits
              title="Overname na 1 jaar"
              text="Zo verzeker je jezelf ervan dat de tijd en kennis die jij hebt geïnvesteerd in deze persoon zich op de lange termijn blijft terugbetalen."
              icon="lock-keyhole-regular"
            />
          </div>
        </div>
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          <img
            src={heroBg}
            alt="description"
            className="absolute left-0 -top-[320px] max-h-[590px] max-w-[800px] object-cover object-left duration-300 md:left-auto md:right-0 md:top-0 md:object-bottom"
          />
        </div>
      </div>

      <div
        className="bg-sl-blue py-10 lg:py-24"
        style={{
          backgroundImage: `linear-gradient(225deg,#0E1C6B 0%,#23275B 100%)`
        }}
      >
        <div className="mx-auto w-full max-w-7xl px-7">
          <Title
            as="h2"
            color="white"
            className="mb-3 text-center"
          >
            Selecteer gespecialiseerde Business Unit
          </Title>
          <CardWorkspaceList
            cards={cards as CardWorkspaceProps[]}
          />
        </div>
      </div>

      <div
        className="bg-white py-10 lg:py-24"
        style={{
          backgroundImage:
            'linear-gradient(to bottom,#f4f4f7,#f7f7f9,#faf9fb,#fcfcfd,#ffffff)'
        }}
      >
        <div className="mx-auto w-full max-w-7xl px-7">
          <div className="mb-9 w-full lg:w-1/2">
            <Title as="h2" size={2} className="mb-5">
              Level up your team
            </Title>
            <Text>
              Synsel Techniek is hét gespecialiseerde
              detacheringsbureau voor elektrotechnici,
              werktuigbouwkundigen, mechatronici en
              automatiseerders binnen Nederland. Wij hebben
              ruime ervaring binnen de machinebouw,
              (proces)industrie en industriële
              automatisering. En misschien wel net zo
              belangrijk, we hebben een missie. Wij zorgen
              ervoor dat jij niet geremd wordt door
              schaarste aan technisch specialisten. Jouw
              machines draaien altijd door. Dan kun jij
              focussen op projecten, servicewerkzaamheden,
              het bouwen van machines en de ontwikkeling van
              je organisatie.
            </Text>
          </div>
          <LogoList images={logos} />
        </div>
        <ImageCarousel slides={slides} />
      </div>
    </>
  );
}

export default Clients;
